import React from "react"
import PropTypes from "prop-types"
import { ErrorIcon } from "components"

const ErrorMessageSection = ({ error }) => (
  <div style={styles.wrapper}>
    <ErrorIcon style={styles.icon} />
    <p style={styles.error}>{error}</p>
  </div>
)

ErrorMessageSection.propTypes = {
  error: PropTypes.string
}

export default ErrorMessageSection

const styles = {
  wrapper: {
    background: "#fceeef",
    padding: "1em"
  },
  error: {
    fontSize: "90%",
    color: "#910A2D",
    textAlign: "left",
    lineHeight: "16px",
    fontWeight: 200,
    margin: "0 0 0 2em"
  },
  icon: {
    height: "1em",
    width: "1em",
    fill: "#910A2D",
    float: "left"
  }
}



// WEBPACK FOOTER //
// ./src/components/error-message-section/index.jsx